export const Select_Option = "Please Select Option";

export const First_Time_Registration_Message =
  "You are successfull register! Plase login";

export const Date_Error = "Please Select Date";

export const Validation_Error = "Please Fill The Required Fields";

export const No_Track_Exist = "No Track Exist";

export const Choose_Workout = "Please Choose Any Workout";

export const Gym_Not_Created =
  "You Have Not Created Any Gym, Please Create A Gym";

export const Session_Expired = "Your Session Has Expired";

export const Notifcation_Not_Supported =
  "Your Browser Does Not Support Notificaitons";

export const errorMessages = {
  athleteRegistration200: "Success",
  athleteRegistration201: "Account Created Successfully",

  editUser200: "User Updated Successfully",
  eidtUser201: "Success",

  connectwithstripe200: "Connected With Stripe Successfully",
  connectwithstripe201: "Success",

  subscriptionwithstripe200: "Success",
  subscriptionwithstripe201: "Success",

  joinGym200: "Gym Joined Successfully",
  joinGym201: "Success",

  joinTrack200: "Track Joined Successfully",
  joinTrack201: "Success",

  gymPersonalRegistraion200: "Success",
  gymPersonalRegistraion201: "Account Created Successfully",

  gymCreation200: "Success",
  gymCreation201: "Gym Created Successfully",

  removeGym200: "Gym Removed Successfully",
  removeGym201: "Success",

  login200: "Successfully logged In",
  login201: "Success",

  forgotpassword200: "Email Has Been Sent, Please! Verify Email",
  forgotpassword201: "Success",

  resetpassword200: "Password Reset Successfull",
  resetpassword201: "Success",

  addTrack200: "Success",
  addTrack201: "Track Added Successfully",

  updateTrack200: "Update Track Successfully",
  updateTrack201: "Update Track Successfully",

  removeTrack200: "Track Removed Successfully",
  removeTrack201: "Success",

  addWorkout200: "Success",
  addWorkout201: "Workout Added Successfully",

  removeWorkout200: "Workout Removed Successfully",
  removeWorkout201: "Success",

  editWorkout200: "Workout Updated Successfully",
  editWorkout201: "Success",

  duplicateWorkout200: "Success",
  duplicateWorkout201: "Workout Duplicated Successfully",

  addScore200: "Score Added Successfully",
  addScore201: "Score Added Successfully",

  deleteScore200: "Score Deleted Successfully",
  deleteScore201: "Score Deleted Successfully",

  updateScore200: "Score Updated Successfully",
  updateScore201: "Score Updated Successfully",

  removeUser200: "Successfully Removed",
  removeUser201: "",

  General_401: "You Are Unauthorized To Perform This Task",
  General_404: "Not Found",
  General_500: "Internal Server Error",
  General_Error: "Somthing went Wrong, Try To Refresh",
  forbidden: "You Are Unauthorized To Perform This Action",
};
